/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Method_Change_ButtonInputs */

const vi_order_payment_method_change_button = /** @type {(inputs: Order_Payment_Method_Change_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi hình thức`)
};

/**

* @param {Order_Payment_Method_Change_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_button = /** @type {((inputs?: Order_Payment_Method_Change_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_button(inputs)
});